import spotGroupIcon from "../assets/icons/spot-group.svg";
import standIcon from "../assets/icons/stand.svg";
import accountIcon from "../assets/icons/account.svg";

const initSettingsSetupMaybeCreateBookable = [
  {
    label: 'Ik heb:',
    name: 'has_spot_group',
    icon: spotGroupIcon,
    button: {
      label: 'Locatie(s)',
    },
    text: [
      'Markten\n' +
      'Evenementen\n' +
      'Winkels\n' +
      'Bedrijventerreinen',
    ],
  },
  {
    label: 'Ik heb:',
    name: 'has_stand',
    icon: standIcon,
    button: {
      label: 'Stand(s)',
    },
    text: [
      'Standhouder\n' +
      'Foodtruck\n' +
      'Marktkraam\n' +
      'Mobiele ondernemer\n' +
      'Ambulante handelaar'
    ],
  },
  {
    label: 'Ik zoek:',
    name: 'searches_stands',
    icon: standIcon,
    button: {
      label: 'Stand(s)',
    },
    text: [
      'Voor mensen/organisaties die op zoek zijn naar stands, trucks, acts'
    ]
  },
  {
    label: 'Ik zoek:',
    name: 'searches_spot_group',
    icon: spotGroupIcon,
    button: {
      label: 'Standplaatsen op locaties',
    },
    text: [
      'Voor mensen/organisaties die op zoek zijn naar standplaatsen op markten, evenementen, winkels of bedrijventerreinen'
    ]
  },
  {
    label: 'Later beslissen',
    name: 'decides_later',
    icon: accountIcon,
    button: {
      label: 'Gast',
      color:"grey-ghost"
    },
    text: [
      'Later beslissen\n',
      'Overig',
    ],
    unique_value: true
  },
]

export default initSettingsSetupMaybeCreateBookable